module.exports = __webpack_public_path__ + "static/img/20241108_6.d1f4683.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newspic/20241108_6.jpg
// module id = Htly
// module chunks = 52